"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _InactiveOrdersComponent = _interopRequireDefault(require("./InactiveOrdersComponent"));
var _orderHistorySelectors = require("../../../redux/selectors/orderHistorySelectors");
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _orderHistoryActions = require("../../../redux/actions/orderHistoryActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var makeMapStateToProps = function makeMapStateToProps() {
  var inactiveOrdersSelector = (0, _orderHistorySelectors.inactiveOrdersSelectorFactory)();
  return function (state, _ref) {
    var config = _ref.config,
      selectedInstrument = _ref.selectedInstrument;
    var activeRequests = state.apexCore.orderHistory.activeRequests;
    var inactiveOrders = inactiveOrdersSelector(state, config);
    var instruments = (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
    var fetching = activeRequests > 0;
    return {
      data: inactiveOrders,
      instruments: instruments,
      fetching: fetching,
      selectedInstrument: selectedInstrument,
      selectedAccountId: (0, _get["default"])(state, 'user.selectedAccountId', 0),
      OMSId: (0, _get["default"])(state, 'user.userInfo.OMSId', 1)
    };
  };
};
var mapDispatchToProps = {
  cancelOrders: _orderHistoryActions.cancelOrders,
  getInactiveOrders: _orderHistoryActions.getInactiveOrders,
  resetActivePage: _orderHistoryActions.resetActivePage
};
var _default = exports["default"] = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps)(_InactiveOrdersComponent["default"]);